// extracted by mini-css-extract-plugin
module.exports = {"MessageMenu":"MessageMenu_MessageMenu__3GrYx","ShortEmojiPickerWrapper":"MessageMenu_ShortEmojiPickerWrapper__UU3yF"};